import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { AccessDeniedComponent } from '@core/components/access-denied/access-denied.component';
import { LoginComponent } from '@core/components/login/login.component';
import { MsalGuard } from '@azure/msal-angular';
import { MainComponent } from '@core/components/main/main.component';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';
import { QueueComponent } from './feature/queue/queue.component';
import { MetricsComponent } from './feature/metrics/metrics.component';
import { RulesTableComponent } from './feature/routing-rules/rules-table/rules-table.component';
import { UnsavedChangesGuard } from '@core/services/unsaved-changes.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: '',
    canActivate: [MsalGuard],
    component: MainComponent,
    children: [
      {
        path: 'rules',
        component: RulesTableComponent,
        title: 'Routing Rules',
        canActivate: [MsalGuard, AccessPageGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: {
          permissions: [
            'PACMAServiceLineRule.Read',
            'PACCOMServiceLineRule.Read',
            'HHServiceLineRule.Read',
            'DMEPOSAuthorizationCaseRule.Read',
            'DMEPOSMedicaidRule.Read',
          ],
        },
      },
      {
        path: 'metrics',
        component: MetricsComponent,
        title: 'Routing Metrics',
        canActivate: [MsalGuard, AccessPageGuard],
        data: {
          permissions: [
            'PACMAServiceLineMetric.Read',
            'PACCOMServiceLineMetric.Read',
            'HHServiceLineMetric.Read',
            'DMEPOSAuthorizationCaseMetric.Read',
            'DMEPOSMedicaidMetric.Read',
          ],
        },
      },
      {
        path: 'queue',
        component: QueueComponent,
        title: 'Routing Queue',
        canActivate: [MsalGuard, AccessPageGuard],
        data: {
          permissions: [
            'PACMAServiceLineQueue.Read',
            'PACCOMServiceLineQueue.Read',
            'HHServiceLineQueue.Read',
            'DMEPOSAuthorizationCaseQueue.Read',
            'DMEPOSMedicaidQueue.Read',
          ],
        },
      },
      {
        path: 'access-denied',
        component: AccessDeniedComponent,
        title: 'Access Denied',
        canActivate: [MsalGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
